<template>
  <scout-form
    label="最終学歴"
    has-child
  >
    <div class="boss-table-2-layout">
      <div
        :class="[{ 'is-modified': value }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="school-career-body"
      >
        <label
          v-for="(option ,i) in educationalBackgroundOptions"
          :key="i"
          class="pega-badge-radio pega-mr-5"
        >
          <input
            :checked="value === option.id"
            :value="option.id"
            :data-test="`education-${option.id}`"
            type="radio"
            @change="$emit('input', $event.target._value)"
          >
          <span
            :data-test="`education-name-${option.id}`"
            class="pega-badge-radio-text pega-badge-radio-check-mark"
          >{{ option.name }}</span>
        </label>
        <label class="display-inline vertical-alien-middle">以上</label>
      </div>
    </div>
    <div
      v-if="from !== undefined && to !== undefined"
      class="boss-table-2-layout"
      data-test="graduated"
    >
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        卒業年
      </div>
      <div
        :class="[{ 'is-modified': from || to }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="graduated-body"
      >
        <input
          v-model="internalFrom"
          :class="{ 'is-invalid-input': isInvalidGraduated }"
          class="boss-input"
          style="width: 6em;"
          type="number"
          max="9999"
          min="1"
          data-test="from"
          @keypress="onlyNumberInRange($event, 9999, 1)"
        >年
        〜
        <input
          v-model="internalTo"
          :class="{ 'is-invalid-input': isInvalidGraduated }"
          class="boss-input"
          style="width: 6em;"
          type="number"
          max="9999"
          min="1"
          data-test="to"
          @keypress="onlyNumberInRange($event, 9999, 1)"
        >年
        <span
          v-if="isInvalidGraduated"
          class="form-error is-visible margin-0"
          data-test="graduated-validation"
        >正しい大小関係で範囲を入力してください。</span>
      </div>
    </div>
    <div
      v-if="freeWord !== undefined"
      class="boss-table-2-layout"
      data-test="graduated-school"
    >
      <div
        class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact"
      >
        学校名・学部名
      </div>
      <div
        :class="[{ 'is-modified': freeWord && operator }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="graduated-school-body"
      >
        「学校名」「学部／学科名」からフリーワード検索を行います。（20文字以内）
        <br>
        <input
          :value="freeWord"
          class="boss-input boss-input-fill"
          type="text"
          placeholder="複数入力時は半角・全角スペースで区切ってください"
          data-test="free-word"
          maxlength="20"
          @change="$emit('update:freeWord', $event.target.value)"
        >
        <div class="boss-separated-small">
          <div class="boss-layout boss-layout-start boss-layout-gap-large">
            <label class="pega-input">
              <input
                :checked="operator === 'and'"
                name="school"
                class="boss-input-checkbox"
                type="radio"
                value="and"
                data-test="operator-and"
                @change="$emit('update:operator', $event.target.value)"
              >すべてのキーワードを含む
            </label>
            <label class="pega-input">
              <input
                :checked="operator === 'or'"
                name="school"
                class="boss-input-checkbox"
                type="radio"
                value="or"
                data-test="operator-or"
                @change="$emit('update:operator', $event.target.value)"
              >いずれかのキーワードを含む
            </label>
          </div>
        </div>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    ScoutForm
  },
  mixins: [eventValidations],
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    freeWord: {
      default: undefined,
      type: String
    },
    operator: {
      default: 'and',
      type: String,
      validator: v => v === 'and' || v === 'or'
    },
    from: {
      default: undefined,
      type: Number
    },
    to: {
      default: undefined,
      type: Number
    }
  },
  computed: {
    educationalBackgroundOptions () {
      return [{ id: null, name: '指定なし' }, ...this.educationalBackgroundMaster]
    },
    isInvalidGraduated () {
      return !!this.from && !!this.to && this.from > this.to
    },
    internalFrom: {
      get () {
        return this.from
      },
      set (value) {
        this.$emit('update:from', value ? Number(value) : null)
      }
    },
    internalTo: {
      get () {
        return this.to
      },
      set (value) {
        this.$emit('update:to', value ? Number(value) : null)
      }
    },
    ...mapGetters([
      'educationalBackgroundMaster'
    ])
  }
}
</script>
